// AUTO-SYNCED from the StreamNook app (C:\StreamNook\src) via `npm run sync:overlay`.
// DO NOT EDIT HERE — edit the renderer in the app repo and re-sync, so the in-app
// builder preview and this hosted overlay stay 1:1.
// Known chat bots (lowercased logins), shared by the stream overlay's "Hide
// bots" filter and the chat widget's chat filters so the two surfaces agree on
// what a bot is. The bot BADGE check below catches channel-specific bots that
// carry one; this list only needs the well-known bots that don't.
export const KNOWN_BOTS = new Set([
  'nightbot', 'streamelements', 'streamlabs', 'moobot', 'fossabot', 'wizebot',
  'sery_bot', 'commanderroot', 'soundtrackbot', 'streamlootsbot', 'pretzelrocks',
  'tangiabot', 'blerp', 'kofistreambot', 'own3d', 'botrixoficial', 'coebot',
  'phantombot', 'thepositivebot', 'streamstickers', 'lattemotte',
  'restreambot', 'supibot', 'anotherttvviewer', 'streamdatabase', 'streamdbbot',
  // Command/utility bots that carry NO bot badge in the chat data (their "Chat Bot"
  // badge is Twitch web-client chrome, not sent over IRC), so only a name catches them.
  'potatbotat', 'pajbot', 'titlechange_bot', 'buttsbot', 'snusbot', 'deepbot',
  'ankhbot', 'vivbot', 'revlobot', 'dixperbro', 'botisimo', 'mikuia', 'wzbot',
  'own3dpro_bot', 'playwithviewersbot', 'thepixelbot', 'cloudbot', '9gag',
]);

// A bot badge. Chatterino and Homies label bot accounts with a badge titled
// exactly "Bot"; Twitch's own bot badge, which FrankerFaceZ-flagged bots also
// carry, says "Chat Bot". Match either, exact (not substring) so cosmetics like
// "Robot" or "Botany" don't trip it.
export const isChatBotBadge = (s?: string): boolean => {
  const v = (s || '').trim().toLowerCase();
  return v === 'bot' || v === 'chat bot';
};
